import { signInWithEmailAndPassword } from '@firebase/auth';
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { auth } from '../../firebase';
import Button from '../button/Button';
import { notify } from '../notify/Notify';
import PageHeader from '../page-header/PageHeader';
import "./login.scss"
export default function Login() {
  const [email,setEmail] = useState('')
  const [password,setPassword] = useState("")
  
  
  const loginHandler = async(e)=>{
    e.preventDefault()
    try {
      await signInWithEmailAndPassword(auth, email, password)
      window.location="/"
    } catch (error) {
      notify(error.message)
    }

  }
    return (
      <>
        <PageHeader>Login</PageHeader>
        <div className="container">
          <div className="section mb-3">
            <form onSubmit={loginHandler} id="login">
              <div className="form__control">
                <label htmlFor="email">Email</label>
                <input
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="example@email.com"
                  name="email"
                  type="email"
                />
              </div>
              <div className="form__control">
                <label htmlFor="password">Password</label>
                <input
                  required
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  placeholder="********"
                  name="password"
                  type="password"
                />
              </div>
              <Button className="login__btn" type="submit">
                Sign in
              </Button>
              <Link to="/register">Register</Link>
            </form>
          </div>
        </div>
      </>
    );
}
